import PropTypes from "prop-types"

import { cn } from "styles/utils"

const SectionList = ({ className = "", ...props }) => (
  <ul
    className={cn(
      "text-neutral text-14 tablet:text-16 tablet:leading-18 leading-16 mb-16 list-disc pl-20 font-light",
      className
    )}
    {...props}
  />
)
SectionList.propTypes = {
  className: PropTypes.string,
}

export default SectionList
